/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Map',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.26545 6.05805C2.10145 6.15176 2.00024 6.32616 2.00024 6.51503V21.0968C2.00024 21.4999 2.43477 21.7533 2.78563 21.5549L8.84204 18.1303L14.8927 21.5517C14.9721 21.5979 15.0634 21.6238 15.1575 21.6239C15.2319 21.624 15.308 21.608 15.3813 21.5732C15.3953 21.5666 15.409 21.5594 15.4223 21.5517L21.7325 17.9835C21.8977 17.8901 21.9998 17.7151 21.9998 17.5254V2.90601C21.9998 2.50189 21.5632 2.24853 21.2123 2.44903L15.1575 5.90882L9.12423 2.46137C9.07005 2.42711 9.00979 2.40259 8.94654 2.38959C8.91165 2.38236 8.87666 2.37889 8.84204 2.37891C8.80742 2.37889 8.77243 2.38236 8.73754 2.38959C8.67429 2.40259 8.61403 2.42711 8.55985 2.46137L2.26545 6.05805ZM3.20024 6.90599V19.9419L8.16891 17.1324V4.06685L3.20024 6.90599ZM15.8311 6.90599V19.9419L20.7998 17.1324V4.06685L15.8311 6.90599ZM14.4838 19.9419V6.90599L9.51518 4.06685V17.1324L14.4838 19.9419Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8479 4.44909L4.2208 8.80745C4.02236 8.92084 3.8999 9.13186 3.8999 9.36041V27.0052C3.8999 27.493 4.42571 27.7997 4.85026 27.5596L12.179 23.4154L19.4928 27.5511C19.5272 27.5718 19.5635 27.5892 19.6011 27.6032C19.6739 27.6304 19.7481 27.6431 19.821 27.643C19.894 27.6431 19.9683 27.6304 20.041 27.6032C20.0786 27.5892 20.1149 27.5718 20.1492 27.5512L27.7768 23.238C27.9766 23.125 28.1002 22.9132 28.1002 22.6836V4.99328C28.1002 4.50428 27.5719 4.19771 27.1473 4.44032L19.821 8.62676L12.5101 4.44909C12.4763 4.42856 12.4406 4.41112 12.4036 4.39706C12.3294 4.36865 12.2535 4.35539 12.179 4.35547C12.1045 4.35539 12.0286 4.36865 11.9544 4.39707C11.9174 4.41113 11.8817 4.42857 11.8479 4.44909ZM5.0999 9.68721V26.0399L11.5419 22.3971V6.00606L5.0999 9.68721ZM12.8161 22.3971V6.00606L19.1839 9.64481V25.9979L12.8161 22.3971ZM20.4581 25.9979V9.64481L26.9002 5.96365V22.3551L20.4581 25.9979Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
